import React from 'react';
import style from './style.module.scss';
import {Tooltip} from 'components/Tooltip';
import {Typography} from 'components/Typography';
import Icon from 'components/Icon';
import cs from 'classnames';

interface IOnlineOnlyLabelProps {
    isAnimated?: boolean;
    className?: string;
}

export const OnlineDiscountBadge = (props: IOnlineOnlyLabelProps) => {
    const {isAnimated, className} = props;

    return (
        <Tooltip
            childrenClassName={style.tooltip}
            overlay={
                <div className={style.tooltip__content}>
                    <Typography variant={'label-12-r'}>Скидка действует только на сайте и в приложении</Typography>
                </div>
            }
        >
            <div className={cs(style.label, className)}>
                <div className={style.label__wrapper}>
                    <div
                        className={cs(style.percentBg, {
                            [style.bgAnimation]: isAnimated,
                        })}
                    />
                    <Icon icon={'percent-online'} width={13} height={13} className={style.percent} />
                </div>
                <Typography className={style.label__text} element={'div'} variant={'p-small'}>
                    Скидка онлайн
                </Typography>
            </div>
        </Tooltip>
    );
};
